module.exports = __webpack_public_path__ + "static/media/chaudfontaine-blauw.c788a882.jpg";